import React, { useCallback, useMemo, useState, memo } from "react";
import moment from "moment";
import styles from "./DateRangePicker.module.scss";
import { DatePicker } from "antd";
import DateRangePickerFooter from "../DateRangePickerFooter/DateRangePickerFooter";
import { useDispatch, useSelector } from "react-redux";

const { RangePicker } = DatePicker;

const DateRangePicker = ({
  storedDatesRange,
  storedSelectedRange,
  getDataByRangeAction,
  handleSelectedRange,
  defineActiveRange,
}) => {
  const dispatch = useDispatch();
  const [isRangePickerOpen, setIsRangePickerOpen] = useState(false);
  const [rangeButtonsDisabled, setRangeButtonsDisabled] = useState(false);

  const onRangeTagHover = useCallback(
    (range) => {
      handleSelectedRange && handleSelectedRange(range);
    },
    []
  );

  const onRangeChange = useCallback(
    (newDateRange) => {
      const customDate = {
        range: newDateRange,
      };
      handleSelectedRange && handleSelectedRange(customDate);
      dispatch(getDataByRangeAction(newDateRange));
    },
    []
  );

  const onCalendarChange = useCallback((dates) => {
    //handleSelectedRange && handleSelectedRange(null);
    setRangeButtonsDisabled(dates.length < 2);
  }, []);

  // const openRangePicker = useCallback(() => {
  //   setIsRangePickerOpen(true);
  // }, [storedDatesRange]);

  const closeRangePicker = useCallback(() => {
    setIsRangePickerOpen(false);
  }, []);

  const onRangeClick = useCallback(
    (range) => {
      handleSelectedRange && handleSelectedRange(range);
      dispatch(getDataByRangeAction(range.range));
      closeRangePicker();
    },
    [storedDatesRange, getDataByRangeAction]
  );

  const dateRangePickerFooter = useCallback(
    () => (
      <DateRangePickerFooter
        storedSelectedRange={storedSelectedRange}
        onRangeClick={(range) => onRangeClick(range)}
        onRangeHover={(range) => onRangeTagHover(range)}
        disabled={rangeButtonsDisabled}
        isActiveFn={defineActiveRange}
      />
    ),
    [onRangeClick, rangeButtonsDisabled, defineActiveRange]
  );

  const rangePickerValue = useMemo(
    () => storedDatesRange.map((date) => moment(date)),
    [storedDatesRange]
  );

  const onOpenChange = useCallback(
    (status) => setIsRangePickerOpen(status),
    []
  );

  return (
    <RangePicker
      open={isRangePickerOpen}
      // onFocus={openRangePicker}
      onOpenChange={onOpenChange}
      className={styles.rangePicker}
      allowClear={false}
      format="DD.MM.YYYY"
      defaultPickerValue={storedDatesRange}
      defaultValue={storedDatesRange}
      value={rangePickerValue}
      onChange={onRangeChange}
      onCalendarChange={onCalendarChange}
      renderExtraFooter={dateRangePickerFooter}
    />
  );
};

export default memo(DateRangePicker);
